import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { AuthContext } from "../context/AuthContext";
import { db, serverTime } from "../Utils/firebase";

function EditColor({ color, changeColor }) {
  const { userData, userAuth, setUserData } = useContext(AuthContext);
  const [disable, setDisable] = useState(true);
  const [btnText, setBtnText] = useState("Save");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mount, setMount] = useState(true);

  const colorRef = useRef();
  const initialColor = color;

  const handleChange = (e) => {
    changeColor(e.target.value);

    if (loading) {
      setDisable(true);
    } else {
      setDisable(false);
      setBtnText("Save");
    }

    if (e.target.value >= 0 && e.target.value <= 365) {
      colorRef.current.style.backgroundColor = `hsl(${e.target.value}, 50%, 50%)`;
    } else if (e.target.value <= 0) {
      colorRef.current.style.backgroundColor = "#e4e4e4";
    } else {
      colorRef.current.style.backgroundColor = "#2b2a2a";
    }
  };

  const handleBlur = () => {
    if (initialColor.toString() === userData.color.toString()) {
      setDisable(true);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      initialColor !== "" &&
      initialColor.toString() !== userData.color.toString()
    ) {
      setDisable(true);
      setBtnText("Saving ...");
      setLoading(true);

      db.collection("user")
        .doc(userAuth.uid)
        .update({
          color: parseInt(initialColor),
          updateAt: serverTime,
        })
        .then(() => {
          db.collection("user")
            .doc(userAuth.uid)
            .get()
            .then((doc) => {
              setUserData(doc.data());
              if (mount) {
                setBtnText("Saved");
                setLoading(false);
              }
            })
            .catch(() => {
              if (mount) {
                setBtnText("Save");
                setLoading(false);
                setError("Failed to load Data!");
              }
            });
        })
        .catch(() => {
          if (mount) {
            setBtnText("Save");
            setLoading(false);
            setError("Somenthing wrong!");
          }
        });
    }
  };

  const getColor = useCallback(() => {
    if (initialColor >= 0 && initialColor <= 365) {
      colorRef.current.style.backgroundColor = `hsl(${initialColor}, 50%, 50%)`;
    } else if (initialColor <= 0) {
      colorRef.current.style.backgroundColor = "#e4e4e4";
    } else {
      colorRef.current.style.backgroundColor = "#2b2a2a";
    }
  }, [initialColor]);

  const renderColor = (number) => {
    if (number >= 0 && number <= 365) {
      return number;
    } else {
      if (number < 0) {
        return "Light";
      } else {
        return "Dark";
      }
    }
  };

  useEffect(() => {
    getColor();
  }, [getColor]);

  useEffect(() => {
    return () => {
      setMount(false);
    };
  }, []);

  return (
    <div className="edit-color divContent darktextColor darkdivColor">
      <div className="head-tab">
        <h5 className="textTitle textMedium">Color</h5>
        <p className="text">
          {error ? (
            <span className="error">{error}</span>
          ) : (
            <span>Set Your Color!</span>
          )}
        </p>
      </div>
      <form className="color-form" onBlur={handleBlur} onSubmit={handleSubmit}>
        <div className="color-wrap">
          <span className="color-number text">{renderColor(initialColor)}</span>
          <span className="color-preview" ref={colorRef}></span>
        </div>
        <input
          type="range"
          max="366"
          min="-1"
          className="slider"
          defaultValue={initialColor}
          onInput={handleChange}
          disabled={loading}
        />
        <button
          className={
            disable
              ? "btn-in darktextColor textTitle disable"
              : "btn-in darktextColor textTitle "
          }
          disabled={loading}
          type="submit"
        >
          {btnText}
        </button>
      </form>
    </div>
  );
}

export default EditColor;
